/* assets/custom-header.js (replace file) */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const addClass = (el, c) => el && el.classList.add(c);
  const removeClass = (el, c) => el && el.classList.remove(c);
  const setAttr = (el, k, v) => el && el.setAttribute(k, v);

  /* ---------------------------
    Cart drawer double-open guard (GLOBAL)
  --------------------------- */
  const OPEN_GUARD_MS = 550;

  const patchOpenGuard = (tagName) => {
    if (!window.customElements || !customElements.whenDefined) return;

    customElements
      .whenDefined(tagName)
      .then(() => {
        const Ctor = customElements.get(tagName);
        if (!Ctor || !Ctor.prototype) return;
        if (Ctor.prototype.__chOpenGuardPatched) return;
        Ctor.prototype.__chOpenGuardPatched = true;

        const patchMethod = (methodName) => {
          const orig = Ctor.prototype[methodName];
          if (typeof orig !== "function") return;

          Ctor.prototype[methodName] = function (...args) {
            const now = Date.now();

            if (window.__chCartOpenAt && now - window.__chCartOpenAt < OPEN_GUARD_MS) return;
            window.__chCartOpenAt = now;

            if (this.__chCartOpenAt && now - this.__chCartOpenAt < OPEN_GUARD_MS) return;
            this.__chCartOpenAt = now;

            return orig.apply(this, args);
          };
        };

        ["open", "openDrawer", "show", "openCartDrawer"].forEach(patchMethod);
      })
      .catch(() => {});
  };

  patchOpenGuard("cart-drawer");
  patchOpenGuard("cart-notification");

  /* ---------------------------
    Open theme cart drawer / notification
  --------------------------- */
  const openThemeCart = (fallbackHref = "/cart") => {
    const cd = document.querySelector("cart-drawer");
    if (cd) {
      if (typeof cd.open === "function") return cd.open();
      if (typeof cd.openDrawer === "function") return cd.openDrawer();
      if (typeof cd.openCartDrawer === "function") return cd.openCartDrawer();
      if (typeof cd.show === "function") return cd.show();
    }

    const cn = document.querySelector("cart-notification");
    if (cn) {
      if (typeof cn.open === "function") return cn.open();
      if (typeof cn.openDrawer === "function") return cn.openDrawer();
      if (typeof cn.show === "function") return cn.show();
    }

    window.location.assign(fallbackHref || "/cart");
  };

  /* ---------------------------
    Helpers
  --------------------------- */
  const getFetchConfig = () => {
    if (typeof window.fetchConfig === "function") return window.fetchConfig("javascript");
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
  };

  const getAddToCartSections = () => {
    const sections = ["cart-icon-bubble"];
    if (document.querySelector("cart-drawer")) sections.unshift("cart-drawer");
    if (document.getElementById("cart-notification")) {
      sections.push("cart-notification-product", "cart-notification-button");
    }
    return sections;
  };

  const setAtcState = (btn, state) => {
    if (!btn) return;
    const defaultLabel = btn.dataset.defaultLabel || btn.textContent.trim() || "ADD TO CART";

    if (!btn.dataset.defaultLabel) btn.dataset.defaultLabel = defaultLabel;

    btn.disabled = state === "loading";

    btn.classList.toggle("is-loading", state === "loading");
    btn.classList.toggle("is-added", state === "added");
    btn.classList.toggle("is-error", state === "error");

    if (state === "loading") btn.textContent = "ADDING...";
    else if (state === "added") btn.textContent = "ADDED";
    else if (state === "error") btn.textContent = "ERROR";
    else btn.textContent = defaultLabel;
  };

  const updateCartBubbleOnly = (sections) => {
    const bubble = document.getElementById("cart-icon-bubble");
    const htmlString = sections?.["cart-icon-bubble"];
    if (!bubble || !htmlString) return;

    const html = new DOMParser().parseFromString(htmlString, "text/html");
    const replacement = html.querySelector(".shopify-section") || html.querySelector("#cart-icon-bubble");
    if (replacement) {
      bubble.innerHTML = replacement.innerHTML;
    }
  };

  const refreshCartDrawerSection = async () => {
    const response = await fetch(`${window.routes?.cart_url || "/cart"}?section_id=cart-drawer`, {
      credentials: "same-origin",
    });
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, "text/html");

    const drawerRoot = document.querySelector("cart-drawer");
    if (!drawerRoot) return false;

    const currentDrawerInner = drawerRoot.querySelector("#CartDrawer");
    const nextDrawerInner = html.querySelector("#CartDrawer");

    if (currentDrawerInner && nextDrawerInner) {
      currentDrawerInner.innerHTML = nextDrawerInner.innerHTML;
    }

    const currentBubble = document.getElementById("cart-icon-bubble");
    const nextBubble = html.querySelector("#cart-icon-bubble");
    if (currentBubble && nextBubble) {
      currentBubble.innerHTML = nextBubble.innerHTML;
    }

    drawerRoot.classList.remove("is-empty");
    const inner = drawerRoot.querySelector(".drawer__inner");
    if (inner) inner.classList.remove("is-empty");

    return true;
  };

  const renderCartFromResponse = async (data, fallbackHref = "/cart") => {
    const cartDrawer = document.querySelector("cart-drawer");
    const cartNotification = document.querySelector("cart-notification");

    if (cartDrawer) {
      try {
        updateCartBubbleOnly(data?.sections || {});
        await refreshCartDrawerSection();
        openThemeCart(fallbackHref);
        return;
      } catch (err) {
        console.error(err);
      }
    }

    if (
      cartNotification &&
      typeof cartNotification.renderContents === "function" &&
      data?.sections?.["cart-notification-product"] &&
      data?.sections?.["cart-notification-button"]
    ) {
      const parsedState = {
        ...data,
        key: data?.key || data?.items?.[data.items.length - 1]?.key,
      };
      cartNotification.renderContents(parsedState);
      return;
    }

    updateCartBubbleOnly(data?.sections || {});
    openThemeCart(fallbackHref);
  };

  const addMegaCardToCart = async (btn) => {
    const variantId = parseInt(btn?.dataset?.variantId || "", 10);
    const fallbackHref = btn?.dataset?.productUrl || "/cart";
    if (!variantId) return;

    setAtcState(btn, "loading");

    try {
      const body = {
        items: [{ id: variantId, quantity: 1 }],
        sections: getAddToCartSections(),
        sections_url: window.location.pathname,
      };

      const response = await fetch(
        (window.routes && window.routes.cart_add_url) || "/cart/add.js",
        {
          ...getFetchConfig(),
          body: JSON.stringify(body),
        }
      );

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || "Cart add failed");
      }

      await renderCartFromResponse(data, fallbackHref);

      setAtcState(btn, "added");
      window.setTimeout(() => {
        setAtcState(btn, "idle");
      }, 1400);
    } catch (err) {
      console.error(err);
      setAtcState(btn, "error");
      window.setTimeout(() => {
        setAtcState(btn, "idle");
      }, 1400);
    }
  };

  /* ---------------------------
    Cart icon click hijack (CAPTURE)
  --------------------------- */
  const bindCartClickOnce = () => {
    if (window.__chCartClickBound) return;
    window.__chCartClickBound = true;

    document.addEventListener(
      "click",
      (e) => {
        if (typeof e.button === "number" && e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        const btn = e.target.closest("[data-ch-cart-open]");
        if (!btn) return;

        const root = btn.closest(".ch-root");
        if (!root) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const href = btn.getAttribute("href") || "/cart";
        openThemeCart(href);
      },
      true
    );
  };

  bindCartClickOnce();

  /* ---------------------------
    Mega card ATC click (CAPTURE)
  --------------------------- */
  const bindMegaAtcOnce = () => {
    if (window.__chMegaAtcBound) return;
    window.__chMegaAtcBound = true;

    document.addEventListener(
      "click",
      (e) => {
        if (typeof e.button === "number" && e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        const btn = e.target.closest("[data-ch-atc]");
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        addMegaCardToCart(btn);
      },
      true
    );
  };

  bindMegaAtcOnce();

  function initHeader(root) {
    if (root?.dataset?.chInited === "1") return;
    root.dataset.chInited = "1";

    const submenuCloseDelay = parseInt(root.dataset.submenuCloseDelay || "160", 10);
    const megaCloseDelay = parseInt(root.dataset.megaCloseDelay || "140", 10);
    const drawerAnimMs = parseInt(root.dataset.drawerAnimMs || "260", 10);

    const wrap = $("[data-header-wrap]", root);
    const spacer = $("[data-header-spacer]", root);
    const mobilebar = $(".ch-mobilebar", root);

    const mmDesktop = window.matchMedia("(min-width: 990px)");
    const isDesktop = () => mmDesktop.matches;

    const getBehavior = () => (root.dataset.headerBehavior || "sticky").toLowerCase();
    const isFixedMode = () => getBehavior() === "fixed";

    const getMain = () =>
      document.querySelector("main#MainContent") ||
      document.querySelector("main") ||
      document.querySelector("[role='main']");

    const mainEl = getMain();
    const ensureMainBasePad = () => {
      if (!mainEl) return;
      if (mainEl.dataset.chBasePadTop) return;
      const pt = parseFloat(getComputedStyle(mainEl).paddingTop) || 0;
      mainEl.dataset.chBasePadTop = String(pt);
    };

    /* ---------------------------
      Find announcement bar (global-first)
    --------------------------- */
    const findAnnbar = () => {
      return (
        document.querySelector("[data-ch-annbar]") ||
        root.querySelector("[data-ch-annbar]") ||
        document.querySelector(".section-header .utility-bar") ||
        document.querySelector(".utility-bar") ||
        document.querySelector(".announcement-bar") ||
        null
      );
    };

    let annbar = findAnnbar();

    const setAnnHiddenClass = (hidden) => {
      if (!annbar) return;
      annbar.classList.toggle("ch-ann-hidden", !!hidden);
    };

    const getAnnVisibleH = () => {
      if (!annbar) return 0;
      const hidden = root.classList.contains("is-ann-hidden");
      setAnnHiddenClass(hidden);
      if (hidden) return 0;
      return Math.round(annbar.getBoundingClientRect().height) || 0;
    };

    const syncAnnVarAndMode = () => {
      root.classList.toggle("is-fixed", isFixedMode());

      const annVisibleH = getAnnVisibleH();
      root.style.setProperty("--ch-ann-visible-h", annVisibleH + "px");
      return annVisibleH;
    };

    const syncMainPadding = () => {
      if (!mainEl) return;

      ensureMainBasePad();
      const base = parseFloat(mainEl.dataset.chBasePadTop || "0") || 0;

      const fixed = isFixedMode();
      const annVisibleH = syncAnnVarAndMode();

      let headerH = 0;
      if (fixed) {
        if (isDesktop()) headerH = wrap ? Math.round(wrap.getBoundingClientRect().height) : 0;
        else headerH = mobilebar ? Math.round(mobilebar.getBoundingClientRect().height) : 0;
      }

      let annAdd = 0;
      if (fixed && annbar) {
        const pos = getComputedStyle(annbar).position;
        if (pos === "fixed") annAdd = annVisibleH;
      }

      const pad = fixed ? headerH + annAdd : 0;
      mainEl.style.paddingTop = base + pad + "px";
    };

    const syncSpacerFallback = () => {
      if (!wrap || !spacer) return;
      if (!isFixedMode() || !isDesktop()) {
        spacer.style.height = "0px";
        return;
      }
      if (mainEl) {
        spacer.style.height = "0px";
        return;
      }
      spacer.style.height = Math.round(wrap.getBoundingClientRect().height) + "px";
    };

    /* ---------------------------
      Announcement hide on scroll
    --------------------------- */
    {
      let ticking = false;
      let lastHidden = root.classList.contains("is-ann-hidden");
      let lockUntil = 0;

      const SHOW_AT = 6;
      const HIDE_AT = 12;

      const applyHidden = (hidden) => {
        if (hidden === lastHidden) return;

        if (hidden) addClass(root, "is-ann-hidden");
        else removeClass(root, "is-ann-hidden");

        lastHidden = hidden;
        lockUntil = Date.now() + 220;

        syncMainPadding();
        syncSpacerFallback();
      };

      const onScroll = () => {
        const now = Date.now();
        if (now < lockUntil) return;

        if (!annbar) annbar = findAnnbar();

        const y = window.scrollY || 0;

        if (y <= SHOW_AT) applyHidden(false);
        else if (y >= HIDE_AT) applyHidden(true);
      };

      onScroll();

      window.addEventListener(
        "scroll",
        () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            ticking = false;
            onScroll();
          });
        },
        { passive: true }
      );
    }

    const hardSync = () => {
      annbar = annbar || findAnnbar();
      syncMainPadding();
      syncSpacerFallback();
    };

    window.addEventListener("resize", hardSync);
    window.addEventListener("load", hardSync);
    requestAnimationFrame(hardSync);
    setTimeout(hardSync, 60);
    setTimeout(hardSync, 240);

    /* ---------------------------
      Secondary dropdown (only one open)
    --------------------------- */
    const submenuItems = $$("[data-submenu-item]", root);
    let submenuTimer = null;

    const syncSubmenuOpenState = () => {
      const anyOpen = submenuItems.some((it) => it.classList.contains("is-open"));
      if (anyOpen) addClass(root, "is-submenu-open");
      else removeClass(root, "is-submenu-open");
    };

    const closeAllSubmenus = (exceptEl = null) => {
      submenuItems.forEach((it) => {
        if (exceptEl && it === exceptEl) return;
        removeClass(it, "is-open");
      });
      syncSubmenuOpenState();
    };

    submenuItems.forEach((item) => {
      const dropdown = $("[data-submenu-dropdown]", item);
      if (!dropdown) return;

      const openThis = () => {
        if (submenuTimer) clearTimeout(submenuTimer);
        closeAllSubmenus(item);
        addClass(item, "is-open");
        syncSubmenuOpenState();
      };

      const scheduleCloseThis = () => {
        if (submenuTimer) clearTimeout(submenuTimer);
        submenuTimer = setTimeout(() => {
          removeClass(item, "is-open");
          syncSubmenuOpenState();
        }, submenuCloseDelay);
      };

      item.addEventListener("mouseenter", openThis);
      item.addEventListener("mouseleave", scheduleCloseThis);
      item.addEventListener("focusin", openThis);
      item.addEventListener("focusout", scheduleCloseThis);
    });

    document.addEventListener("click", (e) => {
      if (!root.contains(e.target)) closeAllSubmenus(null);
    });

    /* ---------------------------
      Localization: auto submit on change
    --------------------------- */
    $$("[data-loc-root] [data-loc-select]", root).forEach((sel) => {
      sel.addEventListener("change", () => {
        const form = sel.closest("form");
        if (form) form.submit();
      });
    });

    /* ---------------------------
      Mega menu open/close
    --------------------------- */
    const megaLayer = $("[data-mega-layer]", root);
    const triggers = $$("[data-mega-trigger]", root);
    const panels = $$("[data-mega-panel]", root);

    let megaOpenKey = null;
    let megaTimer = null;

    const closeMega = () => {
      megaOpenKey = null;
      removeClass(root, "is-mega-open");
      if (megaLayer) setAttr(megaLayer, "aria-hidden", "true");
      panels.forEach((p) => setAttr(p, "aria-hidden", "true"));
      triggers.forEach((t) => {
        const link = $(".ch-mainmenu-link", t);
        if (link) setAttr(link, "aria-expanded", "false");
      });
    };

    const openMega = (key) => {
      if (!megaLayer) return;
      if (megaTimer) clearTimeout(megaTimer);

      megaOpenKey = key;
      addClass(root, "is-mega-open");
      setAttr(megaLayer, "aria-hidden", "false");

      panels.forEach((p) => {
        const match = p.getAttribute("data-mega-panel") === key;
        setAttr(p, "aria-hidden", match ? "false" : "true");
      });

      triggers.forEach((t) => {
        const isMatch = t.getAttribute("data-mega-trigger") === key;
        const link = $(".ch-mainmenu-link", t);
        if (link) setAttr(link, "aria-expanded", isMatch ? "true" : "false");
      });
    };

    const scheduleCloseMega = () => {
      if (megaTimer) clearTimeout(megaTimer);
      megaTimer = setTimeout(() => closeMega(), megaCloseDelay);
    };

    if (triggers.length && megaLayer) {
      triggers.forEach((li) => {
        const key = li.getAttribute("data-mega-trigger");
        li.addEventListener("mouseenter", () => openMega(key));
        li.addEventListener("mouseleave", scheduleCloseMega);

        const a = $(".ch-mainmenu-link", li);
        if (a) a.addEventListener("focus", () => openMega(key));
      });

      megaLayer.addEventListener("mouseenter", () => {
        if (megaTimer) clearTimeout(megaTimer);
      });
      megaLayer.addEventListener("mouseleave", scheduleCloseMega);

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && megaOpenKey) closeMega();
      });

      document.addEventListener("click", (e) => {
        if (!megaOpenKey) return;
        if (!root.contains(e.target)) closeMega();
      });

      $$(".ch-mainmenu-item", root).forEach((it) => {
        if (it.hasAttribute("data-mega-trigger")) return;
        it.addEventListener("mouseenter", () => {
          if (megaOpenKey) closeMega();
        });
        it.addEventListener("focusin", () => {
          if (megaOpenKey) closeMega();
        });
      });
    }

    /* ---------------------------
      Mobile drawer open/close + level transition
    --------------------------- */
    const drawer = $("[data-drawer]", root);
    const openBtn = $("[data-drawer-open]", root);
    const closeBtns = $$("[data-drawer-close]", root);
    const backBtn = $("[data-drawer-back]", root);

    const level0 = $("[data-level='0']", root);
    const level1 = $("[data-level='1']", root);

    let drawerLock = false;
    let lastOpener = null;

    const lock = (fn) => {
      if (drawerLock) return;
      drawerLock = true;
      fn();
      window.setTimeout(() => (drawerLock = false), drawerAnimMs + 40);
    };

    const openDrawer = () => {
      if (!drawer) return;
      addClass(drawer, "is-open");
      setAttr(drawer, "aria-hidden", "false");
      addClass(document.documentElement, "ch-scroll-lock");

      if (level0) addClass(level0, "is-active");
      if (level1) removeClass(level1, "is-active");
      if (level1) setAttr(level1, "aria-hidden", "true");

      const panel = $(".ch-drawer-panel", drawer);
      if (panel) panel.focus({ preventScroll: true });
    };

    const closeDrawer = () => {
      if (!drawer) return;
      removeClass(drawer, "is-open");
      setAttr(drawer, "aria-hidden", "true");
      removeClass(document.documentElement, "ch-scroll-lock");
      if (lastOpener && typeof lastOpener.focus === "function") lastOpener.focus();
    };

    const enterLevel1 = (key) => {
      if (!drawer || !level0 || !level1) return;

      const panelsL1 = $$("[data-drawer-l1]", drawer);
      panelsL1.forEach((p) => {
        const match = p.getAttribute("data-drawer-l1") === key;
        setAttr(p, "aria-hidden", match ? "false" : "true");
      });

      removeClass(level0, "is-active");
      addClass(level1, "is-active");
      setAttr(level1, "aria-hidden", "false");
      drawer.setAttribute("data-active-key", key);
    };

    const backToLevel0 = () => {
      if (!drawer || !level0 || !level1) return;
      addClass(level0, "is-active");
      removeClass(level1, "is-active");
      setAttr(level1, "aria-hidden", "true");
      drawer.removeAttribute("data-active-key");
    };

    if (openBtn) {
      openBtn.addEventListener("click", () => {
        lastOpener = openBtn;
        lock(openDrawer);
      });
    }

    closeBtns.forEach((b) => b.addEventListener("click", () => lock(closeDrawer)));
    if (backBtn) backBtn.addEventListener("click", () => lock(backToLevel0));

    $$("[data-drawer-enter]", root).forEach((btn) => {
      btn.addEventListener("click", () => {
        const key = btn.getAttribute("data-drawer-enter");
        lock(() => enterLevel1(key));
      });
    });

    document.addEventListener("keydown", (e) => {
      if (!drawer || !drawer.classList.contains("is-open")) return;
      if (e.key === "Escape") lock(closeDrawer);
    });
  }

  function boot() {
    $$(".ch-root").forEach(initHeader);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();